module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/basic/basic.component.css
// module id = ./src/app/examples/basic/basic.component.css
// module chunks = main